export const ru = {
    'accept-button': 'Разрешить показы',
    'many-pages-title': 'Разрешите показы на {count} качественных площадках',
    'one-page-title': 'Разрешите показы на {count} качественной площадке',
    'simple-progress-hint': 'Разрешаем показы на качественных площадках',
    'some-pages-title': 'Разрешите показы на {count} качественных площадках',
    'title-hint':
        'Рекомендация показывается, потому что у вас в списке запрещённых есть качественные площадки, приносящие клики'
};
